import * as React from "react";
import { Modal } from "components/bootstrap";
import DashboardsOverview from "views/components/dashboard/DashboardsOverview";
const DashboardsModal = ({ show, onCancel }) => {
  const onClose = () => {
    onCancel();
  };
  return /* @__PURE__ */ React.createElement(Modal, { show, bsSize: "xlarge", onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Add Dashboards")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(DashboardsOverview, { hideDelete: true, hideShare: true, hideAdditionalColumns: true })));
};
export default DashboardsModal;
